export const contactUsPage = {
  heading: 'contact-us-page-heading',
  text: 'contact-us-page-text',
  sectionTitle: 'contact-us-tile-link',
};
